var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "image",
      staticClass: "v-upload__image",
      class: { "is-disabled": _vm.disabled },
      on: { click: _vm.clickFile },
    },
    [
      _c(
        "div",
        { staticClass: "v-upload__image__middle" },
        [
          _vm.uploadType === 0
            ? [
                _c("span", { staticClass: "v-upload__image__icon v-icon-add" }),
                _c("div", { staticClass: "v-upload__image__text" }, [
                  _vm._v(_vm._s(_vm._(""))),
                ]),
              ]
            : _vm._e(),
          _vm.uploadType === 1
            ? [
                _c("span", {
                  staticClass: "v-upload__image__icon v-icon-image",
                }),
              ]
            : _vm._e(),
          _vm.uploadType === 2
            ? [
                _vm.dataImage
                  ? _c("img", {
                      staticClass: "v-upload__image__src",
                      style: {
                        maxHeight: _vm.height + "px",
                        maxWidth: _vm.width + "px",
                      },
                      attrs: { src: _vm.dataImage },
                    })
                  : _c("span", {
                      staticClass: "v-upload__image__icon--big v-icon-image",
                    }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }